import { v4 as uuidv4 } from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export const _generateUniqueKey = (prefix) => `${prefix}-${uuidv4()}`;
